import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider } from '@mui/material'

import CustomSelect from './CustomSelect'
import { elementKeys } from '../../utils/formBuilder'
import { multiSelectionButtonStyles } from '../../styles/classes/GeneralClasses'
import TextBox from './TextBox'

const ButtonsListComponent = ({
  numberOfButtons,
  onChangeSelectionsField,
  maximumNumberOfButtons,
  disableItems,
  numberOfSelectionsOptions,
  itemData,
  buttonsList,
  onChangeButtonValue,
  selectedMoreThanOne
}) => {
  const { classes } = multiSelectionButtonStyles()
  const { t } = useTranslation()

  const buttonListItem = (item, index) => {
    return (
      <TextBox
        error={selectedMoreThanOne && item === ''}
        required
        key={`buttonListItem-${index}`}
        value={item}
        onChange={event => {
          onChangeButtonValue(event, index)
        }}
        title={t('form_builder.elements.button_number_title', {
          number: index + 1
        })}
        placeholder={t('form_builder.elements.button_placeholder')}
        disabled={disableItems}
        small
      />
    )
  }
  return (
    <Fragment>
      <CustomSelect
        nonSortedOptions
        key={elementKeys.NUMBER_OF_BUTTONS}
        name={elementKeys.NUMBER_OF_BUTTONS}
        value={numberOfButtons}
        onChange={onChangeSelectionsField}
        title={t('form_builder.elements.number_of_buttons')}
        options={new Array(maximumNumberOfButtons)
          .fill(1)
          .map((_, idx) => idx + 1)}
        disabled={disableItems}
      />
      <CustomSelect
        key={elementKeys.NUMBER_OF_SELECTIONS}
        name={elementKeys.NUMBER_OF_SELECTIONS}
        value={t(
          `form_builder.elements.${itemData[elementKeys.NUMBER_OF_SELECTIONS]}`
        )}
        onChange={onChangeSelectionsField}
        title={t('form_builder.elements.number_of_selections')}
        options={numberOfSelectionsOptions?.map(item =>
          t(`form_builder.elements.${item}`)
        )}
        disabled={disableItems}
      />
      <Fragment>
        <Divider className={classes.divider} />
        {buttonsList.map((item, index) => buttonListItem(item, index))}
        <Divider className={classes.divider} />
      </Fragment>
    </Fragment>
  )
}

export default ButtonsListComponent
